<script>
  const hire = [
    {
      img: 'slideshow/sail.jpeg',
      alt: 'df',
      h2: 'Dinghy',
      h22: 'Sailing',
      p: 'Royal Yachting Association Dinghy Instructor',
    },

    {
      img: 'slideshow/blunt.jpg',
      alt: '',
      h2: 'Kayak',
      h22: 'Coaching',
      p: 'L2 UKCC coach',
    },
    {
      img: 'slideshow/pb.jpeg',
      alt: '',
      h2: 'PowerBoat',
      h22: '',
      p: 'Royal Yachting Association Powerboat Instructor',
    },
    {
      img: 'slideshow/canoe.jpeg',
      alt: '',
      h2: 'OpenWater',
      h22: 'Canoe',
      p: 'Canoe Leader Trained',
    },
    {
      img: 'slideshow/whitewaterKayak.jpeg',
      alt: '',
      h2: 'Whitewater',
      h22: 'Kayak',
      p: 'Kayak Leader Trained',
    },
    {
      img: 'slideshow/slalom.jpeg',
      alt: '',
      h2: 'Kayak',
      h22: 'Slalom',
      p: 'K1 Slalom Paddler \n (Former Div 1) and Coach',
    },

    {
      img: 'slideshow/PBI.jpeg',
      alt: '',
      h2: 'Mountain',
      h22: 'Nav',
      p: ' ML',
    },
    {
      img: 'slideshow/alicemountain.jpeg',
      alt: '',
      h2: 'Mountain',
      h22: 'Expedition',
      p: 'Mountain Leader Trained working towards an MCI',
    },
    {
      img: 'slideshow/rescue.jpeg',
      // img: 'slideshow/performancepaddling.jpeg',
      alt: '',
      h2: 'Safety',
      h22: '',
      p: 'Event / Film / Competition Safety Cover',
    },

    // ML
    // Wild camping
    // canoe sailing / open
    // ww kayak
    // ww canoe
  ];
</script>

<section class="team text-center section-padding" id="team">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h1 class="arrow">Hire as an outdoor instructor/guide/leader</h1>
      </div>
    </div>
    <div class="row">
      <div class="team-wrapper">
        <div id="teamSlider">
          <ul class="slides">
            <li>
              {#each hire as bx}
                <div class="col-md-4 wp5">
                  <img src={bx.img} alt={bx.alt || bx.h2} />
                  <h2 ><b>{bx.h2}</b> {bx.h22}</h2>
                  <p>
                    {bx.p}
                  </p>
                  <div class="social">
                    <!-- <ul class="social-buttons">
                      <li>
                        <a href="#" class="social-btn"
                          ><i class="fa fa-dribbble" /></a
                        >
                      </li>
                      <li>
                        <a href="#" class="social-btn"
                          ><i class="fa fa-twitter" /></a
                        >
                      </li>
                      <li>
                        <a href="#" class="social-btn"
                          ><i class="fa fa-envelope" /></a
                        >
                      </li>
                    </ul> -->
                  </div>
                </div>
              {/each}

              
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="ignite-cta text-center">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <a href="contact.danielellisresearch.com" class="ignite-btn">Book Now!</a>
      </div>
    </div>
  </div>
</div>


<style>
:root{
--hsize: clamp(300px,30vw,400px);
}

    img {
  object-fit: cover;
  width:var(--hsize);
  height:var(--hsize);
}

    h2:after{
        content: none;
    }

    .slides{
      display: flex;
      gap: 30px;
      column-gap: 2px;
    }
</style>